import { render, staticRenderFns } from "./detail-career.vue?vue&type=template&id=41c83a22&scoped=true&"
import script from "./detail-career.vue?vue&type=script&lang=js&"
export * from "./detail-career.vue?vue&type=script&lang=js&"
import style0 from "./detail-career.vue?vue&type=style&index=0&id=41c83a22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c83a22",
  null
  
)

export default component.exports